import { useContext } from 'react';
import ReactDOM from 'react-dom';
import styled from 'foundations-theming/utils';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "SegmentationFiltersEditorPortalPanel__Container",
  componentId: "if48vi-0"
})(["height:100%;overflow:hidden;"]);
const SegmentationFiltersEditorPortalPanel = props => {
  const {
    props: {
      editorDOMContainer
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const panel = /*#__PURE__*/_jsx(Container, {
    children: props.children
  });
  if (!editorDOMContainer) {
    return null;
  }
  return /*#__PURE__*/ReactDOM.createPortal(panel, editorDOMContainer);
};
export default SegmentationFiltersEditorPortalPanel;